"use client";
import _objectWithoutProperties from '@babel/runtime/helpers/objectWithoutProperties';
import * as React from 'react';
import { Icon } from '../../Icon/Icon.web.js';

var _excluded = ["color", "size"];
var IconWaterPlant = function IconWaterPlant(_ref) {
  var _ref$color = _ref.color,
    color = _ref$color === undefined ? 'currentColor' : _ref$color,
    _ref$size = _ref.size,
    sizeProp = _ref$size === undefined ? '24px' : _ref$size,
    props = _objectWithoutProperties(_ref, _excluded);
  var size = sizeProp;
  return /*#__PURE__*/React.createElement(Icon, props, /*#__PURE__*/React.createElement("svg", {
    fill: "none",
    viewBox: "0 0 24 24",
    width: size,
    height: size
  }, /*#__PURE__*/React.createElement("path", {
    fill: color,
    fillRule: "evenodd",
    d: "M13.68 5h-3.36L8.5 13.1l-1.95-.44L8.72 3h6.56l2.17 9.66-1.95.44zM5.34 16.41a3.9 3.9 0 0 0 4.77.49q.27-.172.52-.37l.37-.23a1.9 1.9 0 0 1 1-.3c.372.004.738.104 1.06.29q.16.107.31.23c.19.14.37.27.54.37a3.9 3.9 0 0 0 2.09.61 3.8 3.8 0 0 0 2.63-1 2 2 0 0 1 2.33-.15L22 14.61a4 4 0 0 0-4.71.35 1.89 1.89 0 0 1-2.35.23l-.39-.27a5 5 0 0 0-.54-.38A3.8 3.8 0 0 0 12 14a3.9 3.9 0 0 0-2.08.62c-.15.1-.3.2-.44.31s-.25.19-.39.27a1.89 1.89 0 0 1-2.38-.28A4 4 0 0 0 2 14.61l1.06 1.7a2 2 0 0 1 2.28.1M17.28 19a1.89 1.89 0 0 1-2.35.23l-.39-.27a4 4 0 0 0-.43-.31A4.14 4.14 0 0 0 12 18a3.8 3.8 0 0 0-2.08.62q-.23.142-.44.31l-.128.092a3 3 0 0 1-.262.178 1.89 1.89 0 0 1-2.38-.28A4 4 0 0 0 2 18.61l1.06 1.7a2 2 0 0 1 2.27.1 3.9 3.9 0 0 0 4.77.49q.27-.172.52-.37l.38-.23a1.8 1.8 0 0 1 1-.3 2 2 0 0 1 1 .29q.16.107.31.23.098.068.192.135c.12.086.236.17.348.235a3.9 3.9 0 0 0 2.15.61 3.8 3.8 0 0 0 2.63-1 2 2 0 0 1 2.33-.15L22 18.61a4 4 0 0 0-4.72.39",
    clipRule: "evenodd"
  })));
};

export { IconWaterPlant, IconWaterPlant as default };
